import { render, staticRenderFns } from "./transformationConfigurations.vue?vue&type=template&id=5c36cb1e&"
import script from "./transformationConfigurations.vue?vue&type=script&lang=js&"
export * from "./transformationConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports